import axiosInstance from '../utils/axiosInstance';

const BASE_PATH = '/admin/recovery-dues';

export async function listRecoveryDues(params = {}) {
  const response = await axiosInstance.get(BASE_PATH, { params });
  return response.data;
}